import React from 'react';
import { UnboundField } from '../../../../formikBindings';
import { IAnswerProps } from './types';

export const TextReadOnlyAnswer: React.FC<IAnswerProps> = ({ name }) => (
  <UnboundField name={name} multiline />
);
